<template>
    <the-header></the-header>

    <main id="app-container" class="container-fluid">
        <router-view key="mainRouter"></router-view>
    </main>
</template>

<script>
import {useStore} from "vuex";
import TheHeader from "./layouts/TheHeader";

export default {
    components: {
        TheHeader,
    },
    mounted() {
        let store = useStore();
        store.dispatch('user/setUserLogged');
    }
}
</script>
